import Button from './Button';
import styles from './ErrorState.module.css';

type ErrorStateProps = {
  message: string;
  onRetry?: () => void;
};

/** ErrorState — shown when an async fetch fails. Always offers a retry when one is possible. */
export default function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className={styles.wrap} role="alert">
      <p className={styles.message}>{message}</p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}
